const initialState = {
  message: "",
};
const ErrorMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ERROR_MESSAGE":
      return (initialState.message = action.payload);
    default:
      return state;
  }
};

export default ErrorMessageReducer;
